import { connect } from 'react-redux';

import { redeemGift } from '../redemption.actions';

import RedemptionAdditionalInfo from './additional-info.component';

import { IRedeemCodeData } from 'types/redemption';
import { Dispatch } from 'types/dispatch';
import { IRedemptionAdditionalInfoDispatchProps, IRedemptionAdditionalInfoStoreProps } from './additional-info.types';

/* We suppress the error here because we have not yet there interface for the store */
// @ts-ignore
const mapStateToProps = (state, ownProps: Object): IRedemptionAdditionalInfoStoreProps => ({
    activeLanguageCode: state.language?.activeLanguageCode,
    redeemData: state.redemption?.redeemData,
    additionalFields: state.redemption?.additionalDetailsDefinition,
    fetching: state.redemption?.fetching,
    ...ownProps
});

const mapDispatchToProps = (dispatch: Dispatch): IRedemptionAdditionalInfoDispatchProps => ({
    redeemGift: (redeemData: IRedeemCodeData) => {
        dispatch(redeemGift(redeemData));
    }
});

const RedemptionAdditionalInfoContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RedemptionAdditionalInfo);

export default RedemptionAdditionalInfoContainer;
